/* GREEN24 Artikelseiten nach GREENAPPLE (AE90, 02.11.2026): Zeichen werden zu Symbolen, nur „→“ bleibt als Pfeil.
   ✓/✔ (aria-hidden) → Häkchen-Linie; ↗ an „Bild vergrößern“ → Lupe; Knöpfe nur mit ←/→ bzw. ‹/› → Linien-Pfeile (Name bleibt im aria-label);
   ↑ ↓ ↗ am Ende von Link- und Knopftexten → „→“. Texte, Ziele und Funktionen bleiben. Läuft erneut, wenn der Kaufbereich neu gezeichnet wird
   (Variantenwechsel). Geladen von sections/g24-artikel-greenapple. */
(function () {
  var NS = 'http://www.w3.org/2000/svg';
  var PFAD = {
    haken: 'M5 12.5l4.5 4.5L19 7.5',
    lupe: 'M10.5 17a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13zM15.5 15.5L20 20',
    links: 'M15 18l-6-6 6-6',
    rechts: 'M9 18l6-6-6-6'
  };
  var HAKEN = /^[✓✔]$/, LINKS = /^[←‹]$/, RECHTS = /^[→›]$/, SCHRAEG = /[↑↓↗↘]/, ENDE = /[↑↓↗↘](\s*)$/;
  function symbol(art) {
    var s = document.createElementNS(NS, 'svg');
    s.setAttribute('class', 'g24-sym g24-sym--' + art);
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('focusable', 'false');
    s.setAttribute('fill', 'none');
    s.setAttribute('stroke', 'currentColor');
    s.setAttribute('stroke-width', '2');
    s.setAttribute('stroke-linecap', 'round');
    s.setAttribute('stroke-linejoin', 'round');
    var p = document.createElementNS(NS, 'path');
    p.setAttribute('d', PFAD[art]);
    s.appendChild(p);
    return s;
  }
  function setze(el, art) { el.textContent = ''; el.appendChild(symbol(art)); }
  function nurPfeilKnopf(el, t) { var b = el.closest('button'); return b && b.textContent.trim() === t; }
  function lauf() {
    var wurzel = document.getElementById('MainContent');
    if (!wurzel) return;
    var spans = wurzel.querySelectorAll('span[aria-hidden="true"]');
    for (var i = 0; i < spans.length; i++) {
      var s = spans[i];
      if (s.children.length) continue;
      var t = s.textContent.trim();
      if (!t) continue;
      if (HAKEN.test(t)) setze(s, 'haken');
      else if (t === '↗' && s.closest('.g24-gallery-help')) setze(s, 'lupe');
      else if (LINKS.test(t) && nurPfeilKnopf(s, t)) setze(s, 'links');
      else if (RECHTS.test(t) && nurPfeilKnopf(s, t)) setze(s, 'rechts');
      else if (SCHRAEG.test(t)) s.textContent = t.replace(/[↑↓↗↘]/g, '→');
    }
    var knoepfe = wurzel.querySelectorAll('button[aria-label]');
    for (var j = 0; j < knoepfe.length; j++) {
      var b = knoepfe[j];
      if (b.children.length) continue;
      var bt = b.textContent.trim();
      if (LINKS.test(bt)) setze(b, 'links');
      else if (RECHTS.test(bt)) setze(b, 'rechts');
    }
    var gang = document.createTreeWalker(wurzel, NodeFilter.SHOW_TEXT, null), n, liste = [];
    while ((n = gang.nextNode())) {
      if (ENDE.test(n.nodeValue) && n.parentElement && n.parentElement.closest('a,button,summary,[class*="__change"]')) liste.push(n);
    }
    for (var k = 0; k < liste.length; k++) liste[k].nodeValue = liste[k].nodeValue.replace(ENDE, '→$1');
  }
  var warte = null;
  function spaeter() { if (warte) clearTimeout(warte); warte = setTimeout(function () { warte = null; lauf(); }, 120); }
  function start() {
    lauf();
    var wurzel = document.getElementById('MainContent');
    if (wurzel && 'MutationObserver' in window) new MutationObserver(spaeter).observe(wurzel, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
